import { render, staticRenderFns } from "./AnnouncementsHome.vue?vue&type=template&id=00c51ccf&scoped=true&"
import script from "./AnnouncementsHome.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsHome.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsHome.vue?vue&type=style&index=0&id=00c51ccf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c51ccf",
  null
  
)

export default component.exports